import React from 'react';
import { Route } from 'react-router-dom';

import AssignAgentModalFromJobDetail from 'modules/journey/AssignAgentModal';
import JobDetail from 'modules/journey/detail';

import Lists from 'modules/tasks/lists';
import Filters from 'modules/tasks/filters';
import AssignOwnerModal from 'modules/tasks/assign-owner/AssignOwnerModal';

import { AssignOwnerProvider } from 'modules/tasks/assign-owner/context';
import { TasksFiltersProvider } from 'modules/tasks/filters/context';
import { SelectedTasksProvider } from 'modules/tasks/lists/context';

const Detail = (props) => <JobDetail showBackButton={false} {...props} />;

const TasksSection = ({ match, className }) => {
  return (
    <TasksFiltersProvider>
      <AssignOwnerProvider>
        <SelectedTasksProvider>
          <div className={className}>
            <div className="side-column">
              <div className="filters-container">
                <Filters />
              </div>
              <div className="list-container">
                <Lists />
              </div>
            </div>
            <div className="main-content">
              <Route path={`${match.url}/:id`} component={Detail} />
            </div>
          </div>
          <AssignAgentModalFromJobDetail />
          <AssignOwnerModal />
        </SelectedTasksProvider>
      </AssignOwnerProvider>
    </TasksFiltersProvider>
  );
};

export default TasksSection;
